import { AxiosInstance } from '../../../utilities/requestClient';
import {
  NavReconFundPositions,
  NavReconFundShareClasses,
  NavReconOverview2Response,
  NavReconOverviewObject,
  NavReconPipelineMetadata,
  UpdateNavReconRiskDataMetaPayload,
} from './types';

/** GET /get_nav_recon_overview/:positionDate — expanded overview grid. */
export const getNavReconOverviewExpanded = async (
  positionDate: string,
): Promise<NavReconOverviewObject[]> => {
  const { data } = await AxiosInstance.get<NavReconOverviewObject[]>(
    `get_nav_recon_overview/${positionDate}`,
  );
  return data ?? [];
};

/** GET /get_nav_recon_overview2/:positionDate — default overview grid. */
export const getNavReconOverview = async (
  positionDate: string,
): Promise<NavReconOverview2Response> => {
  const { data } = await AxiosInstance.get<NavReconOverview2Response>(
    `get_nav_recon_overview2/${positionDate}`,
  );
  return {
    funds: data?.funds ?? [],
    overall_status: data?.overall_status ?? {},
  };
};

/**
 * Fetch NAV-Recon pipeline metadata for a date.
 * GET /get_nav_recon_pipeline_metadata/:positionDate?fund_name=:fundName
 *
 * Omitting `fundName` fetches metadata for all funds.
 */
export const getNavReconPipelineMetadata = async (
  positionDate: string,
  fundName?: string,
): Promise<NavReconPipelineMetadata[]> => {
  const { data } = await AxiosInstance.get<NavReconPipelineMetadata[]>(
    `get_nav_recon_pipeline_metadata/${positionDate}`,
    fundName ? { params: { fund_name: fundName } } : undefined,
  );
  return data;
};

export const updateNavReconRiskDataMeta = async (
  payload: UpdateNavReconRiskDataMetaPayload,
): Promise<unknown> => {
  const { data } = await AxiosInstance.post(
    'update_nav_recon_risk_data_meta',
    payload,
  );
  return data;
};

/** GET /get_nav_recon_share_classes/:positionDate?fund_name=:fundName */
export const getNavReconShareClasses = async (
  positionDate: string,
  fundName: string,
): Promise<NavReconFundShareClasses[]> => {
  const { data } = await AxiosInstance.get<NavReconFundShareClasses[]>(
    `get_nav_recon_share_classes/${positionDate}`,
    { params: { fund_name: fundName } },
  );
  return data;
};

/** GET /get_nav_recon_positions/:positionDate?fund_name=:fundName */
export const getNavReconPositions = async (
  positionDate: string,
  fundName: string,
): Promise<NavReconFundPositions[]> => {
  const { data } = await AxiosInstance.get<NavReconFundPositions[]>(
    `get_nav_recon_positions/${positionDate}`,
    { params: { fund_name: fundName } },
  );
  return data;
};
